module.exports = __webpack_public_path__ + "static/media/recommend3.9f71e7ca.png";